import React from 'react'
import Link from 'next/link'
import { THEME } from 'utils'

const JobsIndex = () => {
  return (
    <div className='jobsPage'>
      <header className='jobsHero'>
        <div className='jobsHero__header'>
          <div className='container'>
            <Link href='/'>
              <a>
                <img src='/static/images/logo-white.png' alt='Barstool Sports' />
              </a>
            </Link>
          </div>
        </div>
        <div className='jobsHero__content'>
          <h1>We are hiring.</h1>
          <p>
            Barstool Sports is a company that will drive the way media is created and consumed for years to come. Join
            us.
          </p>
          <a className='btn btn--primary' href='#openings'>
            Current Openings
          </a>
        </div>
      </header>
      <section className='jobsCollage'>
        <div className='jobsCollage__image'>
          <div className='image' style={{ backgroundImage: `url('/static/images/jobs-1.jpg')` }} />
        </div>
        <div className='jobsCollage__image'>
          <div className='image' style={{ backgroundImage: `url('/static/images/jobs-2.jpg')` }} />
        </div>
        <div className='jobsCollage__image'>
          <div className='image' style={{ backgroundImage: `url('/static/images/jobs-3.jpg')` }} />
        </div>
      </section>
      <section className='perks'>
        <div className='container'>
          <h2>A few perks</h2>
          <div className='row'>
            <div className='col'>
              <div className='perk'>
                <img src='/static/images/perk-1.jpg' />
                <p>Comprehensive medical, dental, and vision benefits</p>
              </div>
            </div>
            <div className='col'>
              <div className='perk'>
                <img src='/static/images/perk-2.jpg' />
                <p>Flexible PTO and WFH</p>
              </div>
            </div>
            <div className='col'>
              <div className='perk'>
                <img src='/static/images/perk-3.jpg' />
                <p>Discounts to the Barstool Store</p>
              </div>
            </div>
            <div className='col'>
              <div className='perk'>
                <img src='/static/images/perk-4.jpg' />
                <p>Company Happy Hours</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='brand'>
        <div className='container'>
          <img src='/static/images/logo-wide.png' />
        </div>
      </section>
      <main className='openings' id='openings'>
        <div className='container'>
          <h1>Current Openings</h1>
          <p>If you don’t see an opening, check back at a later time.</p>
          <div id='grnhse_app'></div>
        </div>
      </main>
      <section className='jobsCollage'>
        <div className='jobsCollage__image'>
          <div className='image' style={{ backgroundImage: `url('/static/images/jobs-4.jpg')` }} />
        </div>
        <div className='jobsCollage__image'>
          <div className='image' style={{ backgroundImage: `url('/static/images/jobs-5.jpg')` }} />
        </div>
        <div className='jobsCollage__image'>
          <div className='image' style={{ backgroundImage: `url('/static/images/jobs-6.jpg')` }} />
        </div>
      </section>
      <style jsx>{`
        .jobsPage {
          overflow-x: hidden;
        }
        .jobsHero {
          position: relative;
          background-image: url('/static/images/jobs-hero.jpg');
          background-size: cover;
          background-repeat: no-repeat;
          height: 520px;
        }
        .jobsHero::before {
          content: '';
          position: absolute;
          z-index: 0;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: rgba(20, 30, 48, 0.7);
          backdrop-filter: blur(3px);
        }
        .jobsHero__header {
          position: relative;
          z-index: 1;
          padding: 30px 0;
        }
        .jobsHero__header img {
          width: auto;
          height: 57px;
        }
        .jobsHero__content {
          position: relative;
          z-index: 1;
          text-align: center;
          max-width: 670px;
          height: calc(100% - 240px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin: auto;
          padding: 0 15px;
        }
        .jobsHero__content h1 {
          font-style: normal;
          font-weight: bold;
          font-size: 45px;
          line-height: 55px;
          color: #ffffff;
          margin: 0;
        }
        .jobsHero__content p {
          font-weight: normal;
          font-size: 17px;
          line-height: 20px;
          color: #ffffff;
          margin-top: 20px;
          margin-bottom: 60px;
        }
        .jobsHero__content .btn {
          max-width: 320px;
          margin: 0 auto;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .jobsPage {
            margin-top: -20px;
            overflow-x: hidden;
          }
          .jobsHero {
            height: 600px;
          }
          .jobsHero__content {
            padding: 0;
          }
          .jobsHero__content h1 {
            font-size: 65px;
            line-height: 75px;
          }
          .jobsHero__content p {
            font-size: 20px;
            line-height: 24px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .jobsHero {
            height: 700px;
          }
          .jobsHero__content h1 {
            font-size: 80px;
            line-height: 98px;
          }
          .jobsHero__content p {
            font-size: 24px;
            line-height: 28px;
          }
        }
        .jobsCollage,
        .perks {
          background: #ffffff;
        }
        .jobsCollage {
          display: flex;
          flex-wrap: nowrap;
          overflow-x: auto;
          margin-left: -5px;
          margin-right: -5px;
        }
        .jobsCollage__image {
          flex-basis: 33%;
          min-width: 170px;
          padding: 10px 5px;
        }
        .jobsCollage__image .image {
          width: 100%;
          background-size: cover;
          background-position: center;
          height: 170px;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .jobsCollage {
            margin-left: -10px;
            margin-right: -10px;
            overflow-x: hidden;
          }
          .jobsCollage__image {
            flex-basis: 33.33%;
            min-width: 33.33%;
            padding: 20px 10px;
          }
          .jobsCollage__image .image {
            height: 300px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .jobsCollage__image .image {
            height: 400px;
          }
        }
        .perks {
          padding: 40px 0;
          text-align: center;
        }
        .perks .col {
          flex-basis: 50%;
          min-width: 50%;
        }
        .perks h2 {
          font-weight: bold;
          font-size: 30px;
          line-height: 36px;
          margin: 0 0 40px;
        }
        .perk img {
          display: block;
          width: auto;
          height: 130px;
          border-radius: 50%;
          margin: 0 auto 25px;
        }
        .perk p {
          font-size: 16px;
          line-height: 140%;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .perks .col {
            flex-basis: 25%;
            min-width: 25%;
          }
          .perks h2 {
            font-size: 40px;
            line-height: 50px;
          }
          .perk img {
            height: 200px;
          }
          .perk p {
            font-size: 18px;
            line-height: 157%;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .perks {
            padding: 60px 0;
          }
          .perks h2 {
            font-size: 50px;
            line-height: 60px;
            margin: 0 0 60px;
          }
        }
        .brand {
          background: ${THEME.COLORS.SECONDARY};
          padding: 40px 0;
        }
        .brand img {
          display: block;
          margin: 0 auto;
          width: 100%;
          max-width: 800px;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .brand {
            padding: 60px 0;
          }
        }
        .openings {
          background: #f5f5f5;
          padding: 60px 0 0;
          margin-bottom: -60px;
        }
        .openings .container {
          min-height: 300px;
        }
        .openings h1 {
          font-weight: bold;
          font-size: 30px;
          line-height: 36px;
          text-align: center;
          margin: 0 0 10px;
          padding: 0 15px;
        }
        .openings p {
          font-family: ${THEME.FONTS.BEBAS};
          font-weight: bold;
          font-size: 22px;
          line-height: 120%;
          text-align: center;
          margin: 0;
          padding: 0 15px;
        }
        .openings .empty {
          font-family: ${THEME.FONTS.HELVETICA};
          font-size: 18px;
          margin-top: 40px;
          color: #666;
        }
        .jobs {
          max-width: 830px;
          margin: auto;
        }
        .jobs__department + .jobs__department {
          margin-top: 60px;
        }
        .jobs__department h3,
        .job__item {
          font-family: ${THEME.FONTS.BEBAS};
          font-weight: bold;
          font-size: 20px;
          line-height: 20px;
        }
        .jobs__department h3 {
          padding-bottom: 8px;
          margin-bottom: 12px;
          border-bottom: 1px solid #999999;
        }
        .jobs__department ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .job__link {
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
          color: #999999;
          padding: 0;
          margin: 16px 0 0;
        }
        .job__title {
          flex-grow: 1;
        }
        .job__location {
          flex-shrink: 0;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .openings h1 {
            font-size: 50px;
            line-height: 65px;
            margin: 0 0 20px;
          }
          .openings p {
            font-size: 26px;
          }
          .jobs__department h3,
          .job__item {
            font-size: 28px;
            line-height: 28px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .openings h1 {
            font-size: 70px;
            line-height: 85px;
          }
          .openings p {
            font-size: 30px;
            line-height: 30px;
          }
          .jobs__department h3,
          .job__item {
            font-size: 35px;
            line-height: 35px;
          }
        }
      `}</style>
    </div>
  )
}

export default JobsIndex
